export default __webpack_public_path__ + "static/media/yasir.78e660a1.jpg";